<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">Administración</li>
  <li class="breadcrumb-item active">Entidades</li>
</ol>

<h1 class="page-header"><i class="fas fa-wrench"></i> Certificación de Procedimientos<small> Configuración de
    Categorias</small></h1>


<div class="scrollable">
  <panel [noButton]="true">

    <div class="row">
      <div class="col-md-4">
        Tipo de Certificación
        <ng-select [items]="certProTypes" bindLabel="name" [(ngModel)]="typeCertPro"
          (ngModelChange)="getCategories()"></ng-select>
      </div>
      <div class="col-md-4">
        Año Seleccionado
        <ng-select [items]="years" [(ngModel)]="yearSelected" (ngModelChange)="getCategories()"></ng-select>
      </div>
    </div>
  </panel>

  <div class="row mt-5">

    <!-- TABS -->
    <div class="col-sm-12 col-lg-4 col-xxl-3">
      <div class="nav flex-column nav-tabs border-end-0" id="myTab" role="tablist">
        @for(category of categories; track $index) {
        <button class="nav-link text-start d-flex justify-content-between align-items-center"
          [class.active]="$index === 0" data-bs-toggle="tab" (click)="selectCategory(category.id)">
          <span>{{$index + 1}} - {{category.name}} @if(category.tooltip){<i class="fas fa-circle-question" triggers="hover"
              [ngbTooltip]="category.tooltip"></i>}</span>
          @if(category.enabled){
          <div class="d-flex">
            @if($index < categories.length - 1) { <button class="btn btn-xs btn-ghost" triggers="hover"
              ngbTooltip="Mover abajo" (click)="moveDown($index)"><i class="fas fa-angle-down"></i>
        </button>
        }
        @if($index > 0) {
        <button class="btn btn-xs btn-ghost" triggers="hover" ngbTooltip="Mover arriba" (click)="moveUp($index)"><i
            class="fas fa-angle-up"></i></button>
        }
        <button class="btn btn-xs btn-ghost" triggers="hover" ngbTooltip="Editar"
          (click)="editCategory(modalNewCategory, category)"><i class="fas fa-edit"></i></button>
        <button class="btn btn-xs btn-ghost" triggers="hover" ngbTooltip="Eliminar"
          (click)="preventRemoveCategory(category.id)"><i class="fas fa-trash"></i></button>
      </div>
      }

      </button>
      }
      @if(categories.length === 0 || categories[0]?.enabled) {
      <button class="btn btn-sm btn-ghost mt-2" (click)="open(modalNewCategory)">
        + Agregar Categoria
      </button>
      }
      <button class="nav-link mt-2" [class.active]="showPreview" (click)="viewPreview()" data-bs-toggle="tab">
        <i class="fas fa-eye"></i> Vista previa
      </button>
    </div>
  </div>


  <div class="col-sm-12 col-lg-8 col-xxl-9">
    <div class="tab-content border rounded bg-white p-4">
      @if(!showPreview){
      <div class="d-flex justify-content-between align-items-center">
        <span class="fs-3 fw-700">Preguntas</span>
        <button class="btn btn-sm btn-primary" (click)="open(modalNewQuestion)">Nueva pregunta</button>
      </div>
      <div class="modal-body mt-5">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>N°</th>
              <th>Criterio</th>
              <th class="col-1 text-center"><i class="fas fa-cogs"></i></th>
            </tr>
          </thead>
          <tbody>
            @for(question of questions; track $index; let iq = $index) {
            <tr>
              <td>{{iq + 1}}</td>
              <td>{{question.title}} @if(question.tooltip){<i class="fas fa-circle-question" triggers="hover"
                  [ngbTooltip]="question.tooltip"></i>}</td>
              <td class="text-end text-nowrap">
                @if(question.enabled){
                @if(iq < questions.length - 1) { <button class="btn btn-xs btn-ghost" (click)="moveDownQuestion(iq)"
                  triggers="hover" ngbTooltip="Mover abajo"><i class="fas fa-angle-down"></i></button>
                  }
                  @if(iq > 0) {
                  <button class="btn btn-xs btn-ghost" (click)="moveUpQuestion(iq)" triggers="hover" triggers="hover"
                    ngbTooltip="Mover arriba"><i class="fas fa-angle-up"></i></button>
                  }
                  <button class="btn btn-xs btn-ghost" (click)="editSubQuestion(modalNewSubQuestion, question)"
                    triggers="hover" ngbTooltip="Agregar subcriterio"><i class="fas fa-arrow-turn-down"></i></button>
                  <button class="btn btn-xs btn-ghost" (click)="editQuestion(modalNewQuestion, question)"
                    triggers="hover" ngbTooltip="Editar"><i class="fas fa-edit"></i></button>
                  <button class="btn btn-xs btn-ghost" (click)="preventRemoveQuestion(question.id)" triggers="hover"
                    ngbTooltip="Eliminar"><i class="fas fa-trash"></i></button>
                }
              </td>
            </tr>
            @for(subquestion of question.subitems; track $index) {
            <tr>
              <td style="padding-left: 20px; width: 35px;">{{iq + 1}}.{{$index + 1}}</td>
              <td>{{subquestion.title}} @if(subquestion.tooltip){<i class="fas fa-circle-question" triggers="hover"
                  [ngbTooltip]="subquestion.tooltip"></i>}</td>
              <td class="text-end text-nowrap">
                @if(question.enabled){
                <button class="btn btn-xs btn-ghost" (click)="moveDownSubQuestion(question, $index)" triggers="hover"
                  ngbTooltip="Mover abajo"><i class="fas fa-angle-down"></i></button>
                <button class="btn btn-xs btn-ghost" (click)="moveUpSubQuestion(question, $index)" triggers="hover"
                  ngbTooltip="Mover arriba"><i class="fas fa-angle-up"></i></button>
                <button class="btn btn-xs btn-ghost"
                  (click)="editSubQuestion(modalNewSubQuestion, question, subquestion)" triggers="hover"
                  ngbTooltip="Editar"><i class="fas fa-edit"></i></button>
                <button class="btn btn-xs btn-ghost" (click)="preventRemoveSubQuestion(subquestion.id)"
                  triggers="hover" ngbTooltip="Eliminar"><i class="fas fa-trash"></i></button>
                }
              </td>
            </tr>
            }
            }
            @empty {
            <tr>
              <td colspan="3" class="text-center">No hay preguntas registradas</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      }@else {
      <div>
        <span class="fs-3 fw-700">Resumen CERTPRO</span>
        <div class="modal-scrollable mt-5">
          <table class="table table-striped table-hover">
            @if(preview){
            <tbody>
              @for(category of preview.categories; track $index; let indexCategory = $index) {
              <tr>
                <td class="text-nowrap fw-bold">{{indexCategory + 1}}</td>
                <td class="fs-5 fw-bold">{{category.name}}</td>
              </tr>
              @for(question of category.questions; track $index; let indexQuestion = $index) {
              <tr>
                <td class="text-nowrap fw-bold">{{indexCategory + 1}}.{{indexQuestion + 1}}</td>
                <td>{{question.title}}</td>
              </tr>
              @for(subquestion of question.subitems; track $index; let indexSubQuestion = $index) {
              <tr>
                <td style="padding-left: 20px;" class="text-nowrap fw-bold">{{indexCategory + 1}}.{{indexQuestion +
                  1}}.{{indexSubQuestion + 1}}</td>
                <td style="padding-left: 30px;">{{subquestion.title}}</td>
              </tr>
              }
              }
              }
            </tbody>
            }
          </table>
        </div>

      </div>
      }
    </div>

  </div>
</div>


<ng-template #modalNewCategory let-c="close" let-d="dismiss">

  <div class="modal-header">
    <span class="fs-3 fw-700">Nueva Categoria</span>
  </div>
  <div class="modal-body" [formGroup]="newCategoryForm">
    <div class="row mb-3">
      <label class="form-label col-form-label col-md-3">Nombre de la categoria</label>
      <div class="col-md-7">
        <input type="text" class="form-control" placeholder="" formControlName="name" />
      </div>
    </div>
    <div class="row mb-3">
      <label class="form-label col-form-label col-md-3">Texto de ayuda</label>
      <div class="col-md-7">
        <textarea rows="5" class="form-control" formControlName="tooltip"></textarea>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-danger" (click)="d('Cross click')">Cerrar</button>
    <button class="btn btn-primary" (click)="d('Cross click'); addCategory()">Guardar</button>
  </div>
</ng-template>


<ng-template #modalNewQuestion let-c="close" let-d="dismiss">

  <div class="modal-header">
    <span class="fs-3 fw-700">Nueva Pregunta</span>
  </div>
  <div class="modal-body" [formGroup]="newQuestionForm">
    <div class="row mb-3">
      <label class="form-label col-form-label col-md-3">Criterio</label>
      <div class="col-md-7">
        <input type="text" class="form-control" placeholder="" formControlName="title" />
      </div>
    </div>
    <div class="row mb-3">
      <label class="form-label col-form-label col-md-3">Texto de ayuda</label>
      <div class="col-md-7">
        <textarea rows="5" class="form-control" formControlName="tooltip"></textarea>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-danger" (click)="d('Cross click')">Cerrar</button>
    <button class="btn btn-primary" (click)="d('Cross click'); addQuestion()">Guardar</button>
  </div>
</ng-template>


<ng-template #modalNewSubQuestion let-c="close" let-d="dismiss">

  <div class="modal-header">
    <span class="fs-3 fw-700">Nueva Subpregunta</span>
  </div>
  <div class="modal-body" [formGroup]="newSubQuestionForm">
    <div class="row mb-3">
      <label class="form-label col-form-label col-md-3">Criterio</label>
      <div class="col-md-7">
        <input type="text" class="form-control" placeholder="" formControlName="title" />
      </div>
    </div>
    <div class="row mb-3">
      <label class="form-label col-form-label col-md-3">Texto de ayuda</label>
      <div class="col-md-7">
        <textarea rows="5" class="form-control" formControlName="tooltip"></textarea>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-danger" (click)="d('Cross click')">Cerrar</button>
    <button class="btn btn-primary" (click)="d('Cross click'); addSubQuestion()">Guardar</button>
  </div>
</ng-template>